import FAQApiHandler from './faq'

// Short-lived, single-use preparation for a policy link the shopper interacts
// with. Never persist policy text or share it across server requests or locales.
const prepared = new Map()
const MAX_AGE = 30000
const keyFor = (type, country, language) => `${country}:${language}:${type}`

const fetchContent = async (type, country, language) => {
  const locale = { shop: country, lang: language }
  const response = await FAQApiHandler.getList(locale)
  if (!Array.isArray(response?.faqs)) throw new Error('FAQ list unavailable')
  const list = response.faqs
  if (type === 'faq' || type === 'cookies-setting')
    return { list, content: null }
  const item = list.find(({ link_rewrite }) => link_rewrite === type)
  if (!item?.id_faq) throw new Error('FAQ not found')
  const detail = await FAQApiHandler.getDetail(item.id_faq, locale)
  if (typeof detail?.content !== 'string' || !detail.content.trim())
    throw new Error('FAQ content unavailable')
  return { list, content: detail.content }
}

const getPrepared = (key) => {
  prepared.forEach((entry, entryKey) => {
    if (Date.now() - entry.createdAt >= MAX_AGE) prepared.delete(entryKey)
  })
  return prepared.get(key)
}

export const prepareFAQ = (type, country, language) => {
  if (typeof window === 'undefined') return undefined
  const key = keyFor(type, country, language)
  if (getPrepared(key)) return undefined
  // Bound unused preparations when navigating between markets/policies.
  if (prepared.size >= 3) prepared.delete(prepared.keys().next().value)
  const entry = {
    createdAt: Date.now(),
    promise: fetchContent(type, country, language),
  }
  prepared.set(key, entry)
  return entry.promise.catch(() => {
    if (prepared.get(key) === entry) prepared.delete(key)
  })
}

export const loadFAQ = (type, country, language) => {
  const key = keyFor(type, country, language)
  const entry = typeof window !== 'undefined' && getPrepared(key)
  prepared.delete(key)
  return entry ? entry.promise : fetchContent(type, country, language)
}
